var map = {
	"./InpostLogo.svg": 56164,
	"./add.svg": 6018,
	"./arrow-left.svg": 7485,
	"./arrow-right.svg": 86191,
	"./arrow_down.svg": 80960,
	"./chat.svg": 43058,
	"./close_icon.svg": 45608,
	"./delete.svg": 64217,
	"./download.svg": 98728,
	"./expand_icon.svg": 67875,
	"./file.svg": 90346,
	"./home.svg": 72781,
	"./info_icon.svg": 3700,
	"./logo-small.svg": 36934,
	"./logo.png": 66949,
	"./logo.svg": 69574,
	"./message_icon.svg": 51697,
	"./profile.svg": 2317,
	"./progress.svg": 96432,
	"./pronunciation.svg": 67186,
	"./sample_profile_img.jpg": 32761,
	"./sample_teacher.png": 78768,
	"./sample_teacher2.png": 63097,
	"./sample_teacher3.png": 30438,
	"./set_class_scene.svg": 96148,
	"./settings.svg": 84369,
	"./star-empty.svg": 12364,
	"./star-filled_icon.svg": 55122,
	"./time-clock-circle_icon.svg": 17394,
	"./togglePasswordView.svg": 50208,
	"./togglePasswordViewError.svg": 53466,
	"./users.svg": 38491,
	"./wordbook.svg": 23950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83809;